export const getEscapedAlgoliaValue = (value: string): string => value.replace(/'/g, "\\'")
